import { addItemToCart } from './cart-service.js';

/**
 * Product Card Custom Element
 * Handles add to cart form submission for product cards
 */

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.form = null;
    this.submitButton = null;
    this.variantInput = null;
    this.isSubmitting = false;
    
    // Bind methods
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  connectedCallback() {
    // Find form and elements
    this.form = this.querySelector('form[action*="/cart/add"]');
    if (!this.form) return;
    
    this.submitButton = this.form.querySelector('button[type="submit"]');
    this.variantInput = this.form.querySelector('input[name="id"]');
    
    // Add submit handler to prevent default form submission
    if (this.form) {
      this.form.addEventListener('submit', this.handleSubmit);
    }
  }

  disconnectedCallback() {
    // Remove event listeners
    if (this.form) {
      this.form.removeEventListener('submit', this.handleSubmit);
    }
  }

  /**
   * Handle form submission
   * Prevents default form submission and uses AJAX to add to cart
   */
  async handleSubmit(event) {
    event.preventDefault();
    
    // Prevent multiple simultaneous submissions
    if (this.isSubmitting) return;
    
    if (!this.form || !this.variantInput) return;
    
    const variantId = this.variantInput.value;
    if (!variantId) {
      console.error('No variant ID found');
      return;
    }
    
    // Get quantity from form (default to 1 if not present)
    const quantityInput = this.form.querySelector('input[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
    
    this.isSubmitting = true;
    
    // Disable button during submission
    const btnDisabledText = this.submitButton.querySelector('[disabled-text]');
    const originalButtonText = btnDisabledText ? btnDisabledText.textContent : null;
    this.submitButton.disabled = true;
    const loadingText = window.umbrellaConfig.addToCart.submit;
    if (btnDisabledText) {
      btnDisabledText.textContent = loadingText;
    }
    
    try {
      await addItemToCart(variantId, quantity, new FormData(this.form));
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert(error.message || 'Failed to add item to cart. Please try again.');
    } finally {
      this.isSubmitting = false;
      
      // Restore button text and state
      if (this.submitButton) {
        if (btnDisabledText && originalButtonText) {
          btnDisabledText.textContent = originalButtonText;
        }
        this.submitButton.disabled = false;
      }
    }
  }
}

// Register the custom element
customElements.define('product-card', ProductCard);

